// src/pages/ComingSoon.jsx
// Shown for pages still in development

import { Link, useLocation } from 'react-router-dom';

const PAGE_NAMES = {
  '/tools':     { name: 'Trading Tools',       icon: '🧮', eta: 'Coming in next update' },
  '/markets':   { name: 'Market Hub',          icon: '📊', eta: 'Coming in next update' },
  '/technical': { name: 'Technical Analysis',  icon: '🔬', eta: 'Coming in next update' },
  '/watchlist': { name: 'Watchlist',           icon: '⭐', eta: 'Coming in next update' },
  '/backtest':  { name: 'Backtester',          icon: '🧪', eta: 'Coming in next update' },
};

export default function ComingSoon() {
  const { pathname } = useLocation();
  const page = PAGE_NAMES[pathname] || { name: 'This page', icon: '🚧', eta: 'Coming soon' };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>{page.icon}</div>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#fff', marginBottom: 8 }}>
          {page.name}
        </h1>
        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 6, lineHeight: 1.7 }}>
          We're still building and testing this feature to make sure it's ready for you.
        </p>
        <p style={{ fontSize: 13, color: '#10b981', marginBottom: 28 }}>
          {page.eta}
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/modules" style={{ padding: '10px 20px', borderRadius: 10, backgroundColor: '#10b981', color: '#fff', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>
            Go to Modules →
          </Link>
          <Link to="/" style={{ padding: '10px 20px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.12)', color: '#9ca3af', textDecoration: 'none', fontSize: 14 }}>
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}